<template>
    <div :class="{card: true, selected: isSelected}" @click="onClick">
      <h2>{{ title }}</h2>      
    <div class="score-info-container">
      <p>{{ value }}番</p>
      <InfoIcon
        fillColor="grey"
        @click.stop="showInfo"
      />
    </div>
    </div>
    <InfoCard 
      v-if="isInfoCardVisible"
      :desc=this.desc
      :image=this.image
      @close="closeInfoCard"
    />
  </template>
  
  <script>
  import InfoCard from "./InfoCard.vue"
  import InfoIcon from 'vue-material-design-icons/Information.vue';

  export default {
    components: { InfoCard, InfoIcon },
    props: {
      title: String,
      value: Number,
      desc: String,
      isSelected: Boolean,
      image: String,
    },
    data() {
      return {
        isInfoCardVisible: false,
      }
    },
    methods: {
      requireImgPath(pic) {
        return require(`@/assets/suits/${pic}`)
      },
      onClick() {
        this.$emit('click')
      },
      showInfo() {
        // handle the info button click logic
        this.isInfoCardVisible = true;
        console.log(this.isInfoCardVisible); 
      },
      closeInfoCard() {
        this.isInfoCardVisible = false;
        console.log(this.isInfoCardVisible)
      }
    }
  };
  </script>
  
  <style src="./OptionCard.css"></style>